export default __webpack_public_path__ + "78654ab9d8414e0675c93c3d6ea6d5f8.png";